import { useCallback, useMemo } from "react";

import type { Permission } from "@lib/permissionConstants";
import { PERMISSION_CONFIGS } from "@lib/permissionConstants";
import sharedConstants from "@lib/shared_constants.json";

import type { RealPermission, RealPermissionValue } from "@services/permissions/types";
import { useFeatureOn } from "@services/useFeatureOn";
import useI18nNamespace from "@services/useI18nNamespace";

/**
 * Fetches PermissionConfig for the specified Permission string value.
 */
export const usePermissionToPermissionConfig = (
  permissionValueToPermission: (permission: RealPermissionValue) => RealPermission
) => {
  const { t: permissionsTranslator } = useI18nNamespace("permission-constants");
  const featureOn = useFeatureOn();

  const permissionToPermissionConfigMap = useMemo(() => {
    return Object.fromEntries(
      PERMISSION_CONFIGS(permissionsTranslator, featureOn as (feature: string) => boolean).flatMap(
        (permissionConfig) => {
          if (permissionConfig.permission !== sharedConstants.PERMISSIONS.PERMISSIONS_BY_VALUE["placeholder"]) {
            return [[permissionValueToPermission(permissionConfig.permission), permissionConfig]];
          }
          return [];
        }
      )
    );
  }, [permissionsTranslator, featureOn, permissionValueToPermission]);

  return useCallback(
    (permission: Permission) => {
      return permissionToPermissionConfigMap[permission];
    },
    [permissionToPermissionConfigMap]
  );
};
